module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/tag-group/tag-group.component.scss
// module id = ./src/app/modules/common-module/components/tag-group/tag-group.component.scss
// module chunks = 9